import { render, staticRenderFns } from "./YouTubeVideo.vue?vue&type=template&id=400c0f92&scoped=true&"
import script from "./YouTubeVideo.vue?vue&type=script&lang=ts&"
export * from "./YouTubeVideo.vue?vue&type=script&lang=ts&"
import style0 from "./YouTubeVideo.vue?vue&type=style&index=0&id=400c0f92&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "400c0f92",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {SingleImage: require('/usr/src/app/components/storyblok/SingleImage.vue').default})
